<nav class="navbar navbar-expand-lg navbar-light fixed-top shadow-sm"
id="mainNav">
<div class="container px-5">
  <a class="navbar-brand fw-bold" href="#page-top">
    <img src="./assets/img/doktorslogo.png" style="width:150px"
  /></a>
    <!-- <div class="btn-group">
      <img *ngIf="islogIn" type="button" class="btn btn-danger dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [src]="profileImage" class="doctorProfile" />
      <div class="dropdown-menu" *ngIf="islogIn">
        <a class="dropdown-item" routerLink="/auth"><i class="fa fa-user-circle-o" aria-hidden="true"></i>My Account</a>
        <div class="dropdown-divider" ></div>
        <a class="dropdown-item" (click)="onLogOut()"><i class="fa fa-sign-out" aria-hidden="true"></i>Log Out</a>
      </div> 
    </div> -->
    
    
  </div>
</nav>
<div class="container pt-5 mt-5">
    <h3 style="text-align: center;padding-top: 15px;">Pricing for booking appointment with <br><b style="color: #00ece9;">Doqma Tokens</b></h3>
   <div class="row container" style="margin-top: 33px;">
    <div class="col-md-2 col-0" ></div>
    <div class="col-md-3 col-12  pricingCard" >
        <h3 class="text-center">Free Appointments</h3>
        <h5><i class="fa fa-check" style="color: #00ece9;" aria-hidden="true"></i> No hassel just click and book appointment</h5>
        <h5><i class="fa fa-check" style="color: #00ece9;" aria-hidden="true"></i> SMS provide</h5>
        <h5><i class="fa fa-check" style="color: #00ece9;" aria-hidden="true"></i> Online support</h5>
        <h5><i class="fa fa-check" style="color: #00ece9;" aria-hidden="true"></i> Mobile notification</h5>
    </div>
    <div class="col-md-2 col-0"></div>
    <br>
    <div class="col-md-3 col-12  pricingCard">
        <h3 class="text-center">2 rupees + (18% GST)</h3>
        <h5><i class="fa fa-check" style="color: #00ece9;" aria-hidden="true"></i> After 2 Free appointment</h5>
        <h5><i class="fa fa-check" style="color: #00ece9;" aria-hidden="true"></i> Online updates</h5>
        <h5><i class="fa fa-check" style="color: #00ece9;" aria-hidden="true"></i> Online support</h5>
        <h5><i class="fa fa-check" style="color: #00ece9;" aria-hidden="true"></i> Most accurate</h5>
        <h5><i class="fa fa-check" style="color: #00ece9;" aria-hidden="true"></i> Mobile notification</h5>
    </div>
    <div class="col-md-2 col-0"></div>
   </div>
   <br>
    <p style="text-align:center"><b>Note :- Prices may increase as per Doctor.</b></p>
</div>
<div class=" pt-3 pb-3" style="background-color: #eeeef5 !important ;position: absolute;bottom: 0;width: 100%;">
    <div class=" text-center ">
      <div class="copyright">
        &copy; Copyright <strong><span>Mavin Globus</span></strong
        >. All Rights Reserved
      </div>
    </div>
    <div class="social-links text-center text-md-right pt-3 pt-md-0">
      <!-- <a href="#" class="twitter"><i class="bi bi-twitter"></i></a> -->
      <!-- <a href="#" class="facebook"><i class="bi bi-facebook"></i></a> -->
      <!-- <a href="#" class="instagram"><i class="bi bi-instagram"></i></a> -->
      <!-- <a href="#" class="google-plus"><i class="bi bi-skype"></i></a> -->
      <!-- <a href="#" class="linkedin"><i class="bi bi-linkedin"></i></a> -->
    </div>
  </div>